export const Email = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="3" y="7" width="26" height="18" rx="1" stroke="currentColor" stroke-width="2"/>
<path d="M29 7L16.0574 15.9603C16.0229 15.9841 15.9772 15.984 15.9429 15.9598L3.20758 7" stroke="currentColor" stroke-width="2"/>
</svg>`;
